// src/components/myjourney/KalonMission.jsx
import React from "react";
import kalon_mission_icon from "../../assets/my_journey_kalon_purpose_icon.png"

export default function KalonMission() {
  const missionPoints = [
    "Empower individuals through discipline, resilience, and structured training.",
    "Provide science-backed, goal-oriented programs for athletes and high performers.",
    "Cultivate sustainable performance habits and mindset for long-term success.",
    "Offer workshops and coaching that instill confidence, capability, and excellence.",
  ];

  return (
    <section className="py-16 px-4 md:px-12 relative w-full overflow-hidden">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black/30 z-0"></div>
      
      {/* Margin line above heading */}
      <div className="w-full flex justify-center mb-12">
        <div className="h-1 bg-gray-500 rounded-full animate-growLine w-4/5 max-w-[90%]"></div>
      </div>

      <div className="relative z-10 max-w-[80%] w-full mx-auto flex flex-col gap-12">
        {/* Section Heading */}
        <div className="flex flex-col items-start gap-6">
        
          <div className="flex items-center gap-3">
            <img
              src={kalon_mission_icon}
              alt="Kalon Mission Icon"
              className="w-11 h-11 md:w-10 md:h-10"
            />
            <h1 className="text-white text-4xl md:text-5xl font-bold underline decoration-gray-400 decoration-1 underline-offset-2">
              Why I created Kalon Fitness
            </h1>
          </div>

          <p className="text-neonTurquoise italic text-lg md:text-xl max-w-3xl text-left animate-fadeIn delay-200">
            A journey dedicated to creating structure, resilience, and holistic growth for high performers and athletes alike.
          </p>
        </div>

        {/* Mission Points */}
        <div className="flex flex-col gap-6">
          {missionPoints.map((point, index) => (
            <div
              key={index}
              className="flex items-start gap-4 animate-fadeInLeft"
              style={{
                animationDelay: `${index * 200}ms`,
                animationFillMode: "both",
              }}
            >
              <span className="text-neonTurquoise text-xl md:text-2xl mt-1">✅</span>
              <p className="text-gray-200 text-lg md:text-xl leading-relaxed">
                {point}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
